// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"460b2c15","147":"92c80c21","266":"60458c20","369":"54e74886","489":"0fc5b6e2","634":"e43a6fc3","656":"6ca37a48","819":"fc5fc734","933":"0eea8ce2"}[chunkId] + ".chunk.js";
};